// extracted by mini-css-extract-plugin
module.exports = {"container":"TabContent_container__2ORID","left":"TabContent_left__2Wk7G","content":"TabContent_content__1cBza","tabs":"TabContent_tabs__31hZB","active":"TabContent_active__1YW52"};